import React from "react";
import { Container, Row, Col, Accordion, Button } from "react-bootstrap";
import Card from "../../../components/Card";

const TermsOfUse = () => {
  return (
    <>
      <Container fluid id="faqAccordion">
        <Row>
          <Col lg="12">
            <Accordion
              className="mm-accordion career-style faq-style"
              defaultActiveKey="0"
            >
              {/* About Us */}
              <Card className="mm-accordion-block accordion">
                <div className="active-faq clearfix" id="headingOne">
                  <Container fluid>
                    <Row>
                      <Col sm="12">
                        <Accordion.Toggle
                          as={Button}
                          href="#"
                          bsPrefix="accordion-title"
                          eventKey="0"
                        >
                          <span>About Us</span>
                        </Accordion.Toggle>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Accordion.Collapse eventKey="0" className="accordion-details">
                  <p className="mb-0">
                    Leapfrog Software Technology Africa PLC, established in
                    2021, is a dynamic Ethiopian company driving digital
                    transformation through telecom distribution, technology
                    solutions, and modern transportation systems. We are
                    dedicated to improving connectivity, efficiency, and
                    accessibility across the country.
                  </p>
                </Accordion.Collapse>
              </Card>

              {/* Vision */}
              <Card className="mm-accordion-block">
                <div className="active-faq clearfix" id="headingTwo">
                  <Container fluid>
                    <Row>
                      <Col sm="12">
                        <Accordion.Toggle
                          as={Button}
                          href="#"
                          bsPrefix="accordion-title"
                          eventKey="1"
                        >
                          <span>Vision</span>
                        </Accordion.Toggle>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Accordion.Collapse className="accordion-details" eventKey="1">
                  <p className="mb-0">
                    To become Ethiopia’s leading partner for telecommunications
                    and tech-driven solutions.
                  </p>
                </Accordion.Collapse>
              </Card>

              {/* Mission */}
              <Card className="mm-accordion-block">
                <div className="active-faq clearfix" id="headingThree">
                  <Container fluid>
                    <Row>
                      <Col sm="12">
                        <Accordion.Toggle
                          as={Button}
                          href="#"
                          bsPrefix="accordion-title"
                          eventKey="2"
                        >
                          <span>Mission Statement</span>
                        </Accordion.Toggle>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Accordion.Collapse className="accordion-details" eventKey="2">
                  <p className="mb-0">
                    To bridge gaps in connectivity, efficiency, and
                    accessibility through advanced telecom solutions and digital
                    innovation.
                  </p>
                </Accordion.Collapse>
              </Card>

              {/* Core Values */}
              <Card className="mm-accordion-block">
                <div className="active-faq clearfix" id="headingFour">
                  <Container fluid>
                    <Row>
                      <Col sm="12">
                        <Accordion.Toggle
                          as={Button}
                          href="#"
                          bsPrefix="accordion-title"
                          eventKey="3"
                        >
                          <span>Core Values</span>
                        </Accordion.Toggle>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Accordion.Collapse className="accordion-details" eventKey="3">
                  <p className="mb-0">
                    • Innovation <br />
                    • Efficiency <br />
                    • Excellence <br />• Collaboration
                  </p>
                </Accordion.Collapse>
              </Card>

              {/* Services */}
              <Card className="mm-accordion-block">
                <div className="active-faq clearfix" id="headingFive">
                  <Container fluid>
                    <Row>
                      <Col sm="12">
                        <Accordion.Toggle
                          as={Button}
                          href="#"
                          bsPrefix="accordion-title"
                          eventKey="4"
                        >
                          <span>Our Services</span>
                        </Accordion.Toggle>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Accordion.Collapse className="accordion-details" eventKey="4">
                  <p className="mb-0">
                    We offer a range of services including: <br />
                    • Telecom distribution – mobile phones, Safaricom SIM cards,
                    internet packages. <br />
                    • EZIBUS digital ticketing and fleet management platform.
                    <br />• Custom ERP and business software solutions to
                    optimize operations.
                  </p>
                </Accordion.Collapse>
              </Card>

              {/* Contact */}
              <Card className="mm-accordion-block">
                <div className="active-faq clearfix" id="headingSix">
                  <Container fluid>
                    <Row>
                      <Col sm="12">
                        <Accordion.Toggle
                          as={Button}
                          href="#"
                          bsPrefix="accordion-title"
                          eventKey="5"
                        >
                          <span>Contact & Locations</span>
                        </Accordion.Toggle>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <Accordion.Collapse className="accordion-details" eventKey="5">
                  <p className="mb-0">
                    Leapfrog Software Technology Africa PLC <br />
                    Addis Ababa, Ethiopia <br />
                    Arada Sub-City, Woreda 01 <br />
                    Phone: +251 111263569 / +251 922005577 / +251 710028383
                    <br />
                    Email: info@leapfrogtechafrica.com <br />
                    Office hours: Monday–Friday 8am–5:30pm, Saturday
                    8am–12:30pm, Sunday Closed.
                  </p>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TermsOfUse;
